import React from 'react';
import { useTheme } from '@mui/material';

interface IProps {
  size: number;
  fill?: string;
}

export const LinkedinIcon = ({ size, fill }: IProps) => {
  const theme = useTheme();
  return (
    <svg id="linkedinicon__assets-icons-v2__svg__l12"
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill={fill ?? 'none'}
    stroke={theme.palette.common.white}
    strokeWidth={1.5}
    strokeLinecap="round"
    strokeLinejoin="round"
    className="icon icon-tabler icons-tabler-outline icon-tabler-brand-linkedin">
      
      <path id="linkedinicon__assets-icons-v2__path__l24" stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path id="linkedinicon__assets-icons-v2__path__l25" d="M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z" />
      <path id="linkedinicon__assets-icons-v2__path__l26" d="M8 11l0 5" />
      <path id="linkedinicon__assets-icons-v2__path__l27" d="M8 8l0 .01" />
      <path id="linkedinicon__assets-icons-v2__path__l28" d="M12 16l0 -5" />
      <path id="linkedinicon__assets-icons-v2__path__l29" d="M16 16v-3a2 2 0 0 0 -4 0" />
    </svg>);

};